module.exports = __webpack_public_path__ + "static/media/example03-01.710780b5.svg";